import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">MR</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-800">Martins Ribeiro</h1>
              <p className="text-sm text-slate-600">Grupo Empresarial</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('historia')}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Nossa História
            </button>
            <button 
              onClick={() => scrollToSection('empresas')}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Nossas Empresas
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Contato
            </button>
            <Button 
              onClick={() => scrollToSection('contato')}
              className="bg-slate-800 hover:bg-slate-900 text-white px-6 py-2 rounded-lg transition-all duration-200 transform hover:scale-105"
            >
              Fale Conosco
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4 animate-in slide-in-from-top duration-200">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('historia')}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Nossa História
              </button>
              <button 
                onClick={() => scrollToSection('empresas')}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Nossas Empresas
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Contato
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;